import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateSrcSet(imagePath: string): string | undefined {
  if (!imagePath || imagePath.startsWith('http') || imagePath.startsWith('data:')) {
    return undefined;
  }

  const parts = imagePath.split('.');
  const ext = parts.pop();
  const base = parts.join('.');

  if (!['jpg', 'jpeg', 'png', 'webp'].includes(ext?.toLowerCase() || '')) {
    return undefined;
  }

  return `${base}-400w.${ext} 400w, ${base}-800w.${ext} 800w`;
}
